import { formatDate } from "../utils/authUtils";

/**
 * Posts can be added here.
 * You can add default posts of your wish with different attributes
 * */

export const posts = [
  {
    _id: "post1",
    content: "Roadmap to become a full stack web3 developer in 180 days.",
    images: ["https://picsum.photos/id/1/800/600"],
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    username: "joweltisso",
    firstName: "Jowel",
    lastName: "Tisso",
    userId: "jowel123",
    avatar: "https://i.pravatar.cc/150?img=60",
    createdAt: "2022-05-16T13:00:21+05:30",
    updatedAt: "2022-05-16T13:00:21+05:30",
  },
  {
    _id: "post2",
    content:
      "Love the idea behind this. A clear goal and how to achieve it. I believe as you go, you would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 3,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
        {
          _id: "erica123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          firstName: "Erica",
          lastName: "Kane",
          username: "erica",
          followers: [],
          following: [],
          bookmarks: [],
          id: "3",
        },
      ],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-06-11T13:00:21+05:30",
    updatedAt: "2022-06-11T13:00:21+05:30",
  },
  {
    _id: "post3",
    content: "A clear goal and how to achieve it",
    images: null,
    likes: {
      likeCount: 2,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
      ],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-04-16T13:00:21+05:30",
    updatedAt: "2022-04-16T13:00:21+05:30",
  },
  {
    _id: "post4",
    content:
      "I believe as you go, you would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    username: "joweltisso",
    firstName: "Jowel",
    lastName: "Tisso",
    userId: "jowel123",
    avatar: "https://i.pravatar.cc/150?img=60",
    createdAt: "2022-05-24T13:00:21+05:30",
    updatedAt: "2022-05-24T13:00:21+05:30",
  },
  {
    _id: "post5",
    content:
      "Love the idea behind this. You would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 4,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
        {
          _id: "tim123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          firstName: "Tim",
          lastName: "Carpenter",
          username: "tim",
          followers: [],
          following: [],
          bookmarks: [],
          id: "3",
        },
        {
          _id: "maris123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          firstName: "Maris",
          lastName: "Sloan",
          username: "maris",
          followers: [],
          following: [],
          bookmarks: [],
          id: "3",
        },
      ],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-06-05T13:00:21+05:30",
    updatedAt: "2022-06-05T13:00:21+05:30",
  },
  {
    _id: "post6",
    content:
      "A clear goal and how to achieve it. I believe as you go, you would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-06-01T13:00:21+05:30",
    updatedAt: "2022-06-01T13:00:21+05:30",
  },
  {
    _id: "post7",
    content:
      "You would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-03-18T13:00:21+05:30",
    updatedAt: "2022-03-18T13:00:21+05:30",
  },
  {
    _id: "post15",
    content:
      "And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 2,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
      ],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-01-21T16:24:10+05:30",
    updatedAt: "2022-01-21T16:24:10+05:30",
  },
  {
    _id: "post8",
    content: "Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    username: "joweltisso",
    firstName: "Jowel",
    lastName: "Tisso",
    userId: "jowel123",
    avatar: "https://i.pravatar.cc/150?img=60",
    createdAt: "2022-01-18T16:24:10+05:30",
    updatedAt: "2022-01-18T16:24:10+05:30",
  },
  {
    _id: "post9",
    content: "Love the idea behind this",
    images: null,
    likes: {
      likeCount: 2,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
      ],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-01-17T16:24:10+05:30",
    updatedAt: "2022-01-17T16:24:10+05:30",
  },
  {
    _id: "post10",
    content:
      "I believe as you go, you would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 2,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
      ],
      dislikedBy: [],
    },
    username: "joweltisso",
    firstName: "Jowel",
    lastName: "Tisso",
    userId: "jowel123",
    avatar: "https://i.pravatar.cc/150?img=60",
    createdAt: "2022-01-11T16:24:10+05:30",
    updatedAt: "2022-01-11T16:24:10+05:30",
  },
  {
    _id: "post11",
    content:
      "A clear goal and how to achieve it. I believe as you go, you would realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 1,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
      ],
      dislikedBy: [],
    },
    username: "joweltisso",
    firstName: "Jowel",
    lastName: "Tisso",
    userId: "jowel123",
    avatar: "https://i.pravatar.cc/150?img=60",
    createdAt: "2022-02-18T16:24:10+05:30",
    updatedAt: "2022-02-18T16:24:10+05:30",
  },
  {
    _id: "post12",
    content:
      "Realize that you need more time with some. And sometimes, I may intend to spend selected hours learning but end up spending more. Wish you the best!👍🏾",
    images: null,
    likes: {
      likeCount: 2,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
      ],
      dislikedBy: [],
    },
    username: "joweltisso",
    firstName: "Jowel",
    lastName: "Tisso",
    userId: "jowel123",
    avatar: "https://i.pravatar.cc/150?img=60",
    createdAt: "2022-03-01T16:24:10+05:30",
    updatedAt: "2022-03-01T16:24:10+05:30",
  },
  {
    _id: "post13",
    content: "Love the idea behind this",
    images: null,
    likes: {
      likeCount: 2,
      likedBy: [
        {
          _id: "jowel123",
          firstName: "jowel",
          lastName: "tisso",
          username: "joweltisso",
          bookmarks: [],
          createdAt: "2022-05-18T16:24:10+05:30",
          updatedAt: "2022-05-18T16:24:10+05:30",
          followers: [],
          following: [],
          id: "1",
        },
        {
          _id: "walker123",
          createdAt: "2022-05-18T16:35:54+05:30",
          updatedAt: "2022-05-18T16:35:54+05:30",
          username: "walker",
          firstName: "Walker",
          lastName: "Rios",
          email: "walker@gmail.com",
          followers: [],
          following: [],
          bookmarks: [],
          id: "2",
        },
      ],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-01-15T16:24:10+05:30",
    updatedAt: "2022-01-15T16:24:10+05:30",
  },
  {
    _id: "post14",
    content:
      "I believe as you go, you would realize that you need more time with some👍🏾",
    images: null,
    likes: {
      likeCount: 0,
      likedBy: [],
      dislikedBy: [],
    },
    username: "walker",
    firstName: "Walker",
    lastName: "Rios",
    userId: "walker123",
    avatar: "https://i.pravatar.cc/150?img=54",
    createdAt: "2022-02-15T16:24:10+05:30",
    updatedAt: "2022-02-15T16:24:10+05:30",
  },
];
